import React from "react";

import { SendNoticeToCRM } from "components/integrations/SendNoticeToCRMButton";
import { DropdownMenu, DropdownMenuItem, DropdownMenuTrigger } from "components/ui/dropdown_menu";
import toast from "components/ui/toast/Toast";
import { copyToClipboard } from "lib/clipboard";
import { NoticeDetails } from "lib/hooks/api/notices/useNotice";
import SaveNoticeToListButton from "./SaveNoticeToListButton";

import css from "./NoticeHeaderDropdown.module.scss";

type OpportunityProps = {
  hasCrm: boolean;
  onShareClick: () => void;
  notice: NoticeDetails;
};

export function NoticeHeaderDropdown({ hasCrm, onShareClick, notice }: OpportunityProps) {
  const onClickCopyUrl = async (e: React.MouseEvent) => {
    e.stopPropagation();

    const noticeUrl = window.location.origin + `/records/${notice.guid}`;
    const copied = await copyToClipboard({ plain: noticeUrl });

    copied ? toast.success("Copied URL") : toast.error("Failed to copy URL");
  };

  return (
    <DropdownMenu
      trigger={
        <DropdownMenuTrigger
          buttonStyle="inverse"
          icon="dotsHorizontal"
          hideArrow
          buttonType="primary"
        />
      }
      align="end"
      width={170}
      modal={false}
    >
      <DropdownMenuItem key="share" onClick={onShareClick} icon="share07">
        Share
      </DropdownMenuItem>
      {hasCrm && (
        <SendNoticeToCRM
          containerClassName={css.crmContainer}
          notice={{
            guid: notice.guid,
            name: notice.name ?? "",
            value: notice.value ?? undefined,
            url: notice.url,
            closeDate: notice.closeDate ?? "",
            type: notice.entityType ?? undefined,
          }}
          type="tertiary"
          align="left"
          fullWidth={true}
        />
      )}
      <DropdownMenuItem key="copy-url" onClick={onClickCopyUrl} icon="link01">
        Copy URL
      </DropdownMenuItem>
      <SaveNoticeToListButton key="save-list" noticeGuid={notice.guid} />
    </DropdownMenu>
  );
}
